import React from 'react';
import { FileSpreadsheet, ListChecks, CheckCircle2, Circle } from 'lucide-react';

const Row = ({ item, n, active, done, onClick }) => (
  <button type="button" onClick={onClick} data-testid={`nav-item-${item.id}`}
    className={`w-full flex items-start gap-2.5 px-3 py-2 rounded-lg text-left transition-colors
      ${active ? 'bg-indigo-600 text-white' : 'hover:bg-slate-100 text-slate-700'}`}>
    {done ? <CheckCircle2 className={`h-4 w-4 mt-0.5 shrink-0 ${active ? 'text-white' : 'text-emerald-500'}`} />
      : <Circle className={`h-4 w-4 mt-0.5 shrink-0 ${active ? 'text-indigo-200' : 'text-slate-300'}`} />}
    <span className="min-w-0">
      <span className="block text-xs font-semibold">
        {n}. {item.kind === 'mcq' ? 'Scenario' : item.label || item.target}
      </span>
      <span className={`block text-[11px] truncate ${active ? 'text-indigo-100' : 'text-slate-500'}`}>
        {item.kind === 'mcq' ? item.prompt : `${item.sheet} · ${item.target}`}
      </span>
    </span>
  </button>
);

export const ItemNavigator = ({ items, activeId, answered, onSelect }) => {
  const sheetItems = items.filter((i) => i.kind !== 'mcq');
  const mcqs = items.filter((i) => i.kind === 'mcq');
  const sheets = [...new Set(sheetItems.map((i) => i.sheet))];
  let n = 0;
  return (
    <nav className="w-72 shrink-0 border-r border-slate-200 bg-white overflow-y-auto p-3 space-y-5" data-testid="item-navigator">
      <section>
        <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-emerald-700 px-2 mb-2">
          <FileSpreadsheet className="h-3.5 w-3.5" /> Spreadsheet tasks · {sheetItems.length}
        </p>
        {sheets.map((sh) => (
          <div key={sh} className="mb-2">
            <p className="text-[10px] font-semibold text-slate-400 px-3 py-1 uppercase tracking-wider">{sh}</p>
            {sheetItems.filter((i) => i.sheet === sh).map((i) => {
              n += 1;
              return <Row key={i.id} item={i} n={n} active={activeId === i.id} done={answered.has(i.id)} onClick={() => onSelect(i)} />;
            })}
          </div>
        ))}
      </section>
      <section>
        <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-amber-700 px-2 mb-2">
          <ListChecks className="h-3.5 w-3.5" /> Scenario questions · {mcqs.length}
        </p>
        {mcqs.map((i) => {
          n += 1;
          return <Row key={i.id} item={i} n={n} active={activeId === i.id} done={answered.has(i.id)} onClick={() => onSelect(i)} />;
        })}
      </section>
    </nav>
  );
};

export default ItemNavigator;
